<template>
    <div class="exchange-wrap">
        <div class="nav-top">
            <a class="return-a" @click="back"></a>
            <h3 class="nav-title">{{txtLang[langName]['exchangeTitle']}}</h3>
        </div>

        <div class="tab-box">
            <ul class="tab-list flex">
                <li v-for="(val, key) in txtLang[langName]['exchangeTab']" @click="tabClick(key)" class="flex-1 flex flex-align-center" :class="(tabIndex==key ? 'on' : '')"><span>{{val}}</span></li>
            </ul>
        </div>

        <div class="exchange-box">
            <ul class="exchange-list" v-if = "isLoadingShow == false && recordList.length > 0">
                <li v-for="(val, key) in recordList">
                    <div class="record-top">
                        <h4>{{val.title}}</h4>
                        <p :style="{display: (val.code !='' ? '' : 'none')}">{{txtLang[langName]['eShopCode'] + val.code}}<a class="copy-btn" @click="copy(val.code)">{{txtLang[langName]['eCopy']}}</a></p>
                        <i :class="(statusCss[val.status])">{{txtLang[langName]['exchangeTab'][val.status]}}</i>
                    </div>
                    <div class="record-info">
                        <p v-if="val.order_no != ''">{{txtLang[langName]['eOrder'] + val.order_no}}</p>
                        <p v-if="val.tickets != ''">{{txtLang[langName]['eCoupon'] + val.tickets + txtLang[langName]['eM']}}</p>
                        <p v-if="val.created_time != ''">{{txtLang[langName]['eStartTime'] + val.created_time}}</p>
                        <p v-if="val.competed_time != ''">{{txtLang[langName]['eEndTime'] + val.competed_time}}</p>
                        <p v-if="val.remark != ''">{{txtLang[langName]['remark'] + '：' + val.remark}}</p>
                    </div>
                </li>
            </ul>
            <noneBox v-else-if = "isLoadingShow == false && recordList.length == 0" :noData="txtLang[langName]['noData']"></noneBox>
        </div>
        <Loading v-show="isLoadingShow"></Loading>
        <Alert ref="Alert" :txt = "alertTip" :time = "1000"/>
    </div>
</template>

<script>
    import Loading from './common/Loading';
    import noneBox from './common/None';
    import Alert from './common/Alert';
    import qs from 'qs';

    export default {
        name: "exchangeRecord",
        components: {
            Loading,
            noneBox,
            Alert
        },

        data(){
            return {
                isLoadingShow: true,
                statusCss: ['', 'change-pending', 'change-success', 'change-failed'],
                tabIndex: 0, //tab索引值
                recordList: [], //兑换记录数据
                alertTip: ''
            }
        },

        methods: {
            back(){//返回上一层
                this.$router.go(-1);
            },

            /**
             * tab切换
             */
            tabClick(index){
                this.tabIndex = index;
                this.loadData({
                    token: localStorage.getItem('guess_token'),
                    lan: this.langIndex,
                    status: this.tabIndex
                });
            },

            /**
             * 复制
             */
            copy(data){
                let code = data;
                let oInput = document.createElement('input');
                oInput.value = code;
                document.getElementById('app').appendChild(oInput);
                oInput.select(); // 选择对象;
                document.execCommand("Copy"); // 执行浏览器复制命令
                this.alertTip = this.txtLang[this.langName]['eCopySuccess'];
                this.$refs.Alert.show();
                oInput.remove();
            },

            /**
             * 兑换记录数据读取
             */
            loadData: function(options){
                var defaults = {
                    token: '',
                    lan: 'en',
                    status: 0
                };

                defaults = Object.assign(defaults, options);

                if(typeof(defaults.status) == 'undefined'){
                    defaults.status = 0;
                }

                const that = this;
                that.isLoadingShow = true;

                this.axios.get(this.getHost() + "/mall/exchange-log?lan="+defaults.lan+'&token='+defaults.token+'&status='+defaults.status).then((response) => {
                    that.isLoadingShow = false;

                    var re = response.data;
                    if(re.code == 200){
                        that.recordList = re.data.list;
                    }
                }).catch((response) => {
                    console.log(response)
                });
            }
        },

        mounted(){//初始化
            if(typeof(this.$route.params.child_type) != 'undefined'){
                this.tabIndex = this.$route.params.child_type*1 + 1;
            }

            this.loadData({
                token: localStorage.getItem('guess_token'),
                lan: this.langIndex,
                status: this.tabIndex
            });
        }
    }
</script>

<style scoped>
    .exchange-wrap{padding-top:120px;}
    /* 顶部菜单 */
    .nav-top{width:100%;height:120px;text-align:center;background:#232048;position:fixed;z-index:110;top:0;left:0;}
    .return-a{display:inline-block;width:120px;height:120px;position:absolute;top:0;left:0;}
    .return-a:after{content:'';position:absolute;width:20px;height:20px;top:50%;left:50%;border-top:4px solid #fff;border-left:4px solid #fff;transform:translate(-50%,-50%) rotate(-45deg);-webkit-transform:translate(-50%,-50%) rotate(-45deg);-moz-transform:translate(-50%,-50%) rotate(-45deg);-o-transform:translate(-50%,-50%) rotate(-45deg);-ms-transform:translate(-50%,-50%) rotate(-45deg);}
    .nav-title{width:64%;margin:0 auto;line-height:120px;color:#fff;font-size:40px;font-weight:normal;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}
    /* tab */
    .tab-box{width:100%;padding:40px 0;background:#171531;position:fixed;top:120px;left:0;z-index:300;}
    .tab-list{width:auto;margin:0 22px;text-align:center;}
    .tab-list li{height:76px;color:#fff;font-size:30px;border-right:2px solid #171531;background:#232048;border-radius:0;}
    .tab-list li span{display:inline-block;width:100%;line-height:30px;color:#fff;font-size:30px;vertical-align:middle;}
    .tab-list li:first-child{margin:0;border-radius:16px 0 0 16px;}
    .tab-list li:last-child{border-radius:0 16px 16px 0;border-right:0;}
    .tab-list li.on span{color:#00ecfd;}
    /* 兑换列表 */
    .exchange-box{padding:156px 22px 18px;}
    .exchange-list{}
    .exchange-list li{padding:24px 32px;margin-bottom:22px;border-radius:16px;background:#3b3860;}
    .record-top{position:relative;}
    .record-top h4{width:70%;color:#fefefe;font-size:30px;font-weight:normal;}
    .record-top p{padding-top:14px;color:#6770e6;font-size:24px;}
    .copy-btn{height:36px;line-height:36px;padding:0 28px;margin-left:10px;color:#fff;font-size:24px;text-align:center;border:3px solid #6371ea;border-radius:8px;background:#4f55a5;}
    .record-top i{height:30px;line-height:24px;padding:4px;font-size:20px;font-style:normal;text-align:center;border-radius:6px;position:absolute;top:4px;right:0;}
    .record-top i.change-success{color:#00d9cd;background:#626080;}
    .record-top i.change-pending{color:#fffefe;background:#e74f6b;}
    .record-top i.change-failed{color:#3b3860;background:#626080;}
    .record-info{margin-top:28px;padding-top:20px;border-top:2px solid #626080;}
    .record-info p{line-height:40px;color:#bbbabf;font-size:20px;}
</style>


// WEBPACK FOOTER //
// src/components/exchangeRecord.vue